(() => {
  const banner = document.querySelector('[data-ca-app-banner]');
  if (!banner) return;

  const userAgent = navigator.userAgent || '';
  const isAndroid = /Android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isSafari = isIOS && /Safari/i.test(userAgent) && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent);

  if ((!isAndroid && !isIOS) || isSafari) return;

  const dismissedAt = Number(window.localStorage.getItem('ca-app-banner-dismissed-at') || 0);
  const dismissalWindow = 7 * 24 * 60 * 60 * 1000;
  if (dismissedAt && Date.now() - dismissedAt < dismissalWindow) return;

  const action = banner.querySelector('[data-ca-app-banner-action]');
  const close = banner.querySelector('[data-ca-app-banner-close]');
  if (!action || !close) return;

  const appStoreUrl = banner.dataset.appStoreUrl;
  const playStoreUrl = banner.dataset.playStoreUrl;

  if (isAndroid) {
    const fallback = encodeURIComponent(playStoreUrl);
    action.href = `intent:#Intent;action=android.intent.action.MAIN;category=android.intent.category.LAUNCHER;package=au.com.comealive.ComeAliveFrames;S.browser_fallback_url=${fallback};end`;
    action.textContent = 'Open or get';
    action.setAttribute('aria-label', 'Open Come Alive, or get it from Google Play');
  } else {
    action.href = 'comealive://';
    action.textContent = 'Open app';
    action.setAttribute('aria-label', 'Open the Come Alive app');
    action.addEventListener('click', () => {
      const startedAt = Date.now();
      window.setTimeout(() => {
        if (document.visibilityState === 'visible' && Date.now() - startedAt < 1800) {
          window.location.assign(appStoreUrl);
        }
      }, 900);
    });
  }

  close.addEventListener('click', () => {
    window.localStorage.setItem('ca-app-banner-dismissed-at', String(Date.now()));
    banner.hidden = true;
  });

  banner.hidden = false;
})();
